module.exports = {
    RECEIVE_NATURE: 'RECEIVE_NATURE',
    RECEIVE_ALL_NATURE: 'RECEIVE_ALL_NATURE',
}